import React from 'react';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface QuestionsQualificationsAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const QuestionsQualificationsAccordion: React.FC<
  QuestionsQualificationsAccordionProps
> = ({ jobData, expanded, onChange }) => {
  const classes = useStyles();

  // Use actual data from striive job schema
  const striive_job = jobData.striive_job;

  // Parse questions JSON data if available
  const getQuestionsData = (questions: any) => {
    if (!questions) return [];

    try {
      const parsed =
        typeof questions === 'string' ? JSON.parse(questions) : questions;
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const questionsArray = getQuestionsData(striive_job?.questions);

  // Filter questions to only show those where isCandidate is false
  const filteredQuestions = questionsArray.filter(
    (question: any) => question.isCandidate === false,
  );

  // Process each question to get the display value
  const processQuestion = (question: any) => {
    const { answer } = question;

    // For the selected answer, use the actual answer
    const selectedAnswer = answer && answer.trim() !== '' ? answer : 'N/A';

    return {
      question: question.question,
      selectedAnswer,
    };
  };

  const processedQuestions = filteredQuestions.map(processQuestion);

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value} style={{ wordBreak: 'break-word' }}>
        {value}
      </Typography>
    </Grid>
  );

  return (
    <JobAccordion
      title="QUESTIONS AND QUALIFICATIONS"
      expanded={expanded}
      onChange={onChange}
    >
      <Grid container spacing={3}>
        {processedQuestions.map((questionData, index) => {
          const { question, selectedAnswer } = questionData;

          return (
            <React.Fragment key={index}>
              {/* Render the question with selected answer only */}
              {renderDetailItem(`${question}:`, selectedAnswer)}
            </React.Fragment>
          );
        })}

        {/* Show message if no questions available */}
        {processedQuestions.length === 0 && (
          <Grid item xs={12}>
            <Typography className={classes.value}>
              No questions data available
            </Typography>
          </Grid>
        )}
      </Grid>
    </JobAccordion>
  );
};
